<template>
  <article class="garage-details">
    <h2 class="garage-details__header">O warsztacie</h2>

    <GarageAbout
      v-if="garage?.description && (garage?.description?.length || 0) > 20"
      class="garage-details__about"
      :html="garage.description"
    />

    <div class="garage-details__wrapper">
      <div class="garage-details__additional-infos">
        <!-- PHONE -->
        <div class="garage-details__additional-info">
          <div class="garage-details__additional-info-row-header">
            <div class="d-flex align-items-center">
              <div class="garage-details__additional-info-icon-wrapper">
                <NuxtImg
                  src="/_nuxt/telephone.svg"
                  width="20px"
                  height="20px"
                  alt="Numer telefonu"
                />
              </div>
              Numer telefonu
            </div>
          </div>
          <div
            v-show="expandableContent.phone"
            class="garage-details__additional-info-row-value"
          >
            <span class="garage-details__phone-virtual">{{ phoneVirtual }}</span>
            <a
              @click="modals.phone = true"
              role="button"
            >Pokaż numer telefonu</a>
          </div>
        </div>

        <!-- ADDRESS -->
        <div class="garage-details__additional-info">
          <div class="garage-details__additional-info-row-header">
            <div class="d-flex align-items-center">
              <div class="garage-details__additional-info-icon-wrapper">
                <NuxtImg
                  src="/_nuxt/pin.svg"
                  alt="Adres serwisu"
                  width="20px"
                  height="20px"
                />
              </div>
              Adres serwisu
            </div>
          </div>

          <div
            v-show="expandableContent.address"
            class="garage-details__address-wrapper"
          >
            <div class="garage-details__address-content">
              <div><span>{{ garage?.address }}</span>, </div>
              <div v-if="garage?.postalCode"><span>{{ garage?.postalCode }}</span>, </div>
              <div><span>{{ garage?.city }}</span></div>
              <span
                @click="$emit('show-map')"
                class="garage-details__show-map-info"
              > Zobacz na mapie</span>
            </div>
          </div>
        </div>

        <!-- OPEN HOURS -->
        <div class="garage-details__additional-info">
          <div
            @click="expandableContent.open_hours = !expandableContent.open_hours"
            class="garage-details__additional-info-row-header"
          >
            <div class="d-flex align-items-center">
              <div class="garage-details__additional-info-icon-wrapper">
                <NuxtImg
                  src="/_nuxt/clock.svg"
                  width="20px"
                  height="20px"
                  alt="Godziny otwarcia"
                />
              </div>
              Godziny otwarcia
            </div>
            <i
              class="i-arrow-down"
              :class="{ 'rotated-icon': expandableContent.open_hours }"
            ></i>
          </div>

          <div
            v-if="expandableContent.open_hours"
            class="garage-details__additional-info-row-value"
          >
            <div
              class="garage-details__opening-wrapper"
              v-if="garageWorkTime"
            >
              <div
                class="garage-details__opening"
                :class="{ 'garage-details__open': checkIsToday(1) }"
              >Poniedziałek
                <div
                  v-if="!!garageWorkTime.monday?.open"
                  class="garage-details__opening-hours"
                >
                  <div class="garage-details__opening-hour">{{ garageWorkTime.monday?.from }}</div>
                  <div class="garage-details__opening-hour-divider">-</div>
                  <div class="garage-details__opening-hour">{{ garageWorkTime.monday?.to
                    }}</div>
                </div>
                <div v-else>Zamknięte</div>
              </div>

              <div
                class="garage-details__opening"
                :class="{ 'garage-details__open': checkIsToday(2) }"
              >Wtorek
                <div
                  v-if="!!garageWorkTime.tuesday?.open"
                  class="garage-details__opening-hours"
                >
                  <div class="garage-details__opening-hour">{{ garageWorkTime.tuesday?.from }}</div>
                  <div class="garage-details__opening-hour-divider">-</div>
                  <div class="garage-details__opening-hour">{{ garageWorkTime.tuesday?.to
                    }}</div>
                </div>
                <div v-else>Zamknięte</div>
              </div>

              <div
                class="garage-details__opening"
                :class="{ 'garage-details__open': checkIsToday(3) }"
              >Środa
                <div
                  v-if="!!garageWorkTime.wednesday?.open"
                  class="garage-details__opening-hours"
                >
                  <div class="garage-details__opening-hour">{{ garageWorkTime.wednesday?.from }}</div>
                  <div class="garage-details__opening-hour-divider">-</div>
                  <div class="garage-details__opening-hour">{{ garageWorkTime.wednesday?.to
                    }}</div>
                </div>
                <div v-else>Zamknięte</div>
              </div>

              <div
                class="garage-details__opening"
                :class="{ 'garage-details__open': checkIsToday(4) }"
              >Czwartek
                <div
                  v-if="!!garageWorkTime.thursday?.open"
                  class="garage-details__opening-hours"
                >
                  <div class="garage-details__opening-hour">{{ garageWorkTime.thursday?.from }}</div>
                  <div class="garage-details__opening-hour-divider">-</div>
                  <div class="garage-details__opening-hour">{{ garageWorkTime.thursday?.to
                    }}</div>
                </div>
                <div v-else>Zamknięte</div>
              </div>

              <div
                class="garage-details__opening"
                :class="{ 'garage-details__open': checkIsToday(5) }"
              >Piątek
                <div
                  v-if="!!garageWorkTime.friday?.open"
                  class="garage-details__opening-hours"
                >
                  <div class="garage-details__opening-hour">{{ garageWorkTime.friday?.from }}</div>
                  <div class="garage-details__opening-hour-divider">-</div>
                  <div class="garage-details__opening-hour">{{ garageWorkTime.friday?.to
                    }}</div>
                </div>
                <div v-else>Zamknięte</div>
              </div>

              <div
                class="garage-details__opening"
                :class="{ 'garage-details__open': checkIsToday(6) }"
              >Sobota
                <div
                  v-if="!!garageWorkTime.saturday?.open"
                  class="garage-details__opening-hours"
                >
                  <div class="garage-details__opening-hour">{{ garageWorkTime.saturday?.from }}</div>
                  <div class="garage-details__opening-hour-divider">-</div>
                  <div class="garage-details__opening-hour">{{ garageWorkTime.saturday?.to
                    }}</div>
                </div>
                <div v-else>Zamknięte</div>
              </div>

              <div
                class="garage-details__opening"
                :class="{ 'garage-details__open': checkIsToday(0) }"
              >Niedziela
                <div
                  v-if="!!garageWorkTime.sunday?.open"
                  class="garage-details__opening-hours"
                >
                  <div class="garage-details__opening-hour">{{ garageWorkTime.sunday?.from }}</div>
                  <div class="garage-details__opening-hour-divider">-</div>
                  <div class="garage-details__opening-hour">{{ garageWorkTime.sunday?.to
                    }}</div>
                </div>
                <div v-else>Zamknięte</div>
              </div>
            </div>
          </div>

          <div
            v-else
            class="garage-details__additional-info-row-value"
          >
            <div
              class="garage-details__opening"
              :class="{ 'garage-details__open': checkIsToday(currentDayAsNumber) }"
            >
              <div
                v-if="!!currentDayGarageWorkTime?.open"
                class="garage-details__opening-today"
                :class="{ 'garage-details__opening-today--vacation': !!garageVacationInfo?.vacation?.from }"
              >
                {{ openTo }}
              </div>
            </div>
          </div>
        </div>

        <!-- PAYMENT METHODS -->
        <div class="garage-details__additional-info">
          <div class="garage-details__additional-info-row-header">
            <div class="d-flex align-items-center">
              <div class="garage-details__additional-info-icon-wrapper">
                <NuxtImg
                  src="/_nuxt/paymentMethod.svg"
                  width="20px"
                  height="20px"
                  alt="Formy płatności"
                />
              </div>
              Metody płatności
            </div>
          </div>

          <div
            v-show="expandableContent.payment_methods"
            class="garage-details__additional-info-row-value"
          >
            <div class="d-flex">
              <div v-if="!!garage?.paymentWithCash">Gotówka</div>
              <div v-if="!!garage?.paymentWithCreditCard">/ Karta</div>
            </div>
          </div>
        </div>

        <!-- TERMS -->
        <div class="garage-details__additional-info">
          <div class="garage-details__additional-info-row-header">
            <div class="d-flex align-items-center">
              <div class="garage-details__additional-info-icon-wrapper">
                <NuxtImg
                  src="/_nuxt/info.svg"
                  width="20px"
                  height="20px"
                  alt="Polityka warsztatu"
                />
              </div>
              Polityka warsztatu
            </div>
          </div>

          <div
            v-show="expandableContent.terms"
            class="garage-details__additional-info-row-value"
          >
            <div
              v-if="garage?.noClientParts"
              class="garage-details__terms-row"
            >
              <NuxtImg
                src="/_nuxt/no-client-parts.svg"
                width="20px"
                height="20px"
                alt="Warsztat nie naprawia na częściach klienta"
              />
              <div class="garage-details__terms-row">Warsztat nie pracuje na częściach klienta</div>
            </div>
            <div
              v-else
              class="garage-details__terms-row"
            >
              <NuxtImg
                src="/_nuxt/client-parts.svg"
                width="20px"
                height="20px"
                alt="Warsztat nie naprawia na częściach klienta"
              />
              <div class="garage-details__terms-row">Warsztat oferuje możliwość napraw na częściach dostarczonych przez
                klienta</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <GaragePhoneModal
      v-if="!!garage && modals.phone"
      :modals="modals"
      :phone-number="garage?.phone"
      :garagePremium="garagePremium"
      :suggestedGarages="suggestedGarages"
      :garage="garage"
      :garageVirtualPhones="garageVirtualPhones"
    />
  </article>
</template>

<script setup lang="ts">
import type { GarageJsonldGarageReadGarageReadIdGarageReadNameGarageSlugHistoryReadSuggestedGarageRead, GarageVacationJsonldVacationRead, GarageVirtualPhoneNumberJsonldVirtualPhoneRead, GarageWorkTimeJsonldWorkTimeRead, RankingJsonldSuggestedGarageReadRankingRead } from '~/api/docs/api';
import GaragePhoneModal from '@/components/GaragePhoneModal.vue';
import GarageAbout from '@/components/GarageAbout.vue';
import dayjs from 'dayjs';
import { dayNumberToString } from '~/helpers/dayjs';

interface IProps {
  garage?: GarageJsonldGarageReadGarageReadIdGarageReadNameGarageSlugHistoryReadSuggestedGarageRead;
  garageWorkTime?: GarageWorkTimeJsonldWorkTimeRead;
  totalComments?: number;
  garagePremium: boolean;
  suggestedGarages?: RankingJsonldSuggestedGarageReadRankingRead[];
  garageVirtualPhones: GarageVirtualPhoneNumberJsonldVirtualPhoneRead[];
  garageVacationInfo?: GarageVacationJsonldVacationRead;
}

interface IEmits {
  (name: 'show-map'): void;
}

const expandableContent: Ref<any> = ref({
  description: false,
  address: true,
  open_hours: false,
  payment_methods: true,
  phone: true,
  website: false,
  terms: true
});

const modals = ref({
  phone: false
});

// emits
const emits = defineEmits<IEmits>();

const props = defineProps<IProps>();

// methods
const checkIsToday = (day: number): boolean => {
  return dayjs().get('day') === day;
};

// computed
const phoneVirtual = computed(() => {
  const phone = !!props.garageVirtualPhones?.length ? props.garageVirtualPhones[0].phoneVirtual : props.garage?.phone;

  return `${phone?.substring(0, 6)}... `;
});

const currentDayAsNumber = computed(() => {
  return dayjs().get('day');
});

const currentDayGarageWorkTime = computed(() => {
  return props.garageWorkTime?.[`${dayNumberToString(dayjs().get('day'))}`];
});

const openTo = computed(() => {
  const day = dayNumberToString(dayjs().get('day'));
  const openHours = props.garageWorkTime?.[`${day}`];

  if (props.garageVacationInfo?.vacation?.from) {
    return 'Zamknięte z powodu urlopu';
  }

  return !!openHours?.open ? `Dziś otwarte do ${openHours.to}` : `Dziś zamknięte`;
});

</script>

<style lang="scss" scoped>
@import url('assets/styles/components/garage-details.scss');
</style>